import { Badge, Button, Card, Col, Row, Typography ,Popover } from "antd";
import { SolutionOutlined , DeleteOutlined, EditOutlined,} from "@ant-design/icons";
import { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
	deleteSale,
	loadSingleSale,
} from "../../redux/rtk/features/nonGstSale/nonGstSaleSlice";
import CardComponent from "../Card/card.components";
import ReturnSaleInvoiceList from "../Card/saleInvoice/ReturnSaleInvoiceList";
import SaleProductListCard from "../Card/saleInvoice/SaleProductListCard";
import TransactionSaleList from "../Card/saleInvoice/TransactionSaleList";
import PackingSlip from "../Invoice/PackingSlip";
import PackingSlip1 from "../Invoice/PackingSlip1";
import SaleInvoiceA4 from "../Invoice/SaleInvoiceA4";
import SaleInvoiceA5 from "../Invoice/SaleinvoiceA5";
import SaleInvoice from "../Invoice/SaleInvoice";
import SaleInvoiceV1 from "../Invoice/SaleInvoiceV1";
import SaleInvoiceV1A5 from "../Invoice/SaleInvoiceV1A5";
import PosPrint from "../Invoice/PosPrint";
import PosPrint1 from "../Invoice/PosPrint1";
import PosPrint3inch from "../Invoice/PosPrint3inch";
import PosPrint4inch from "../Invoice/PosPrint4inch";
import PosPrint3inch1 from "../Invoice/PosPrint3inch1";
import PosPrint4inch1 from "../Invoice/PosPrint4inch1";
import SaleInvoiceV2A4 from "../Invoice/SaleInvoiceV2A4";
import SaleInvoiceV3A4 from "../Invoice/SaleInvoiceV3A4";
import Loader from "../loader/loader";
import ChangeOrderStatus from "./ChangeOrderStatus";
import { getTemplateSetting } from "../../api/getSettings";
import _ from "lodash";
import { handleSendInvoice } from "../pos/AddPos.utils";
import { Tooltip } from "antd";
//PopUp

const DetailNonGstSale = () => {
	const { id } = useParams();
	let navigate = useNavigate();

	const invoiceContainerRef = useRef();
	const [loadingSendInvoice, setLoadingSendInvoice] = useState(false);

	//dispatch
	const dispatch = useDispatch();
	const sale = useSelector((state) => state?.nonGstSales?.sale);
	const {
		status,
		totalPaidAmount,
		totalReturnAmount,
		dueAmount,
		singleNonGstSaleInvoice,
		returnNonGstSaleInvoice,
		transactions,
	} = sale ? sale : {};

	let totalVatAmount  = singleNonGstSaleInvoice?.productTax || 0
	const [returnTotal, setReturnTotal] = useState(0);
	
	useEffect(() => {
		if(singleNonGstSaleInvoice?.nonGstSaleInvoiceProduct){
			const returnTotalSum = _.reduce(singleNonGstSaleInvoice?.nonGstSaleInvoiceProduct, (total, current) => total + (current.productQuantity < 0 ? current.productSalePrice : 0), 0);
			setReturnTotal(returnTotalSum);
		}
	}, [singleNonGstSaleInvoice]);

	//Delete Customer
	const onDelete = () => {
		const deleteSuccessCallBack = () => {
			setVisible(false);
			toast.warning(`Sale : ${id} is removed `);
			return navigate("/admin/branch-sale");
		}
		try {
			dispatch(deleteSale({ id, deleteSuccessCallBack }));
		} catch (error) {
			console.log(error.message);
		}
	};
	// Delete Customer PopUp
	const [visible, setVisible] = useState(false);

	const handleVisibleChange = (newVisible) => {
		setVisible(newVisible);
	};

	useEffect(() => {
		dispatch(loadSingleSale(id));
	}, [id]);

	const invoiceData = useSelector((state) => state.accounts.appSettings);
	const templateData = useSelector((state) => state.accounts.templateSettings);

	const isLogged = Boolean(localStorage.getItem("isLogged"));

	if (!isLogged) {
		return <Navigate to={"/admin/auth/login"} replace={true} />;
	}

	const storeGSTCode = (invoiceData?.gst_no)?.slice(0,2);
	const customerGSTCode = (singleNonGstSaleInvoice?.customer?.gst_no)?.slice(0,2);

	return (
		<div>
			<div className='mr-top'>
				{singleNonGstSaleInvoice ? (
					<Fragment key={singleNonGstSaleInvoice.id}>
						<Card bordered={false} className='card-custom'>
							<div className="flex justify-between">
								<h5 className='m-2 text-xl'>
								<SolutionOutlined />
								<span className='mr-left'>ID : {singleNonGstSaleInvoice.manualId} |</span>
								</h5>

							<div>
								    <Link
                					    className='mr-3 d-inline-block'
                					    to={`/admin/branch-sale/${singleNonGstSaleInvoice.id}/update`}
                					    state={{ data: sale }}
                					  ><Tooltip title="Edit">
                					    <Button
                					      type='primary'
                					      shape='round'
                					      icon={<EditOutlined />}
                					    ></Button></Tooltip>
                					</Link>
                					<Popover
                					    content={
                					      <a onClick={onDelete}>
                					        <Button type='primary' danger>
                					          Yes Please !
                					        </Button>
                					      </a>
                					    }
                					    title='Are you sure you want to delete ?'
                					    trigger='click'
                					    visible={visible}
                					    onVisibleChange={handleVisibleChange}
                					  ><Tooltip title="Delete">
                					    <Button
                					      type='danger'
                					      shape='round'
                					      icon={<DeleteOutlined />}
                					    ></Button></Tooltip>
                					  </Popover>
									  {/* <CommonDelete
                    					id={id}
                    					className={"p-1 w-11 h-11 text-xl"}
                    					permission={"delete-sale"}
                    					deleteThunk={deleteSale}
                    					navigatePath={"/admin/branch-sale"}
                  					/> */}
							</div>
							</div>
							<div className='card-header flex justify-center '>
								<div className='mr-2'>
									<Link
										to={`/admin/payment/customer/${singleNonGstSaleInvoice.id}`}
										state={{ dueAmount: dueAmount, isNonGstSaleInvoice: true }}>
										<Button
											type='primary'
											className='btn-sm'
											disabled={!dueAmount}>
											Payment
										</Button>
									</Link>
								</div>
								<div className='mr-2'>
									<Link to={`/admin/branch-sale/return/${id}`}>
										<Button type='primary' shape='round'>
											{" "}
											Return Product{" "}
										</Button>
									</Link>
								</div>

                                {templateData?.invoiceTemplate === 'a4medic' && (
								<div className={"text-end mr-2"}>
									<SaleInvoiceA4
										data={{ ...singleNonGstSaleInvoice, returnTotal }}
										vatAmount={totalVatAmount}
										invoiceContainerRef={invoiceContainerRef}
                                        productsKey={"nonGstSaleInvoiceProduct"}
									/>
								</div>
								)}
								{templateData?.invoiceTemplate === 'a5medic' && (
								<div className={"text-end mr-2"}>
									<SaleInvoiceA5
										data={{ ...singleNonGstSaleInvoice, returnTotal }}
										vatAmount={totalVatAmount}
										invoiceContainerRef={invoiceContainerRef}
                                        productsKey={"nonGstSaleInvoiceProduct"}
									/>
								</div>
								)}
								{templateData?.invoiceTemplate === 'a4print' && (
								<div className={"text-end mr-2"}>
									<SaleInvoice
										data={{ ...singleNonGstSaleInvoice, returnTotal }}
										vatAmount={totalVatAmount}
										invoiceContainerRef={invoiceContainerRef}
                                        productsKey={"nonGstSaleInvoiceProduct"} 
									/>
								</div>
							     )}
							     {templateData?.invoiceTemplate === 'v1a4print' && (
							   	<div className={"text-end mr-2"}>
									<SaleInvoiceV1
										data={{ ...singleNonGstSaleInvoice, returnTotal }}
										vatAmount={totalVatAmount}
										invoiceContainerRef={invoiceContainerRef}
                                        productsKey={"nonGstSaleInvoiceProduct"} 
									/>
							   	</div>
							     )}
							     {templateData?.invoiceTemplate === 'v1a5print' && (
							   	<div className={"text-end mr-2"}>
							   		<SaleInvoiceV1A5
							   			data={{ ...singleNonGstSaleInvoice, returnTotal }}
							   			vatAmount={totalVatAmount}
										invoiceContainerRef={invoiceContainerRef}
                                        productsKey={"nonGstSaleInvoiceProduct"} 
							   		/>
							   	</div>
							     )}
							     {templateData?.invoiceTemplate === 'v2a4print' && (
							   	<div className={"text-end mr-2"}>
										<SaleInvoiceV2A4
											data={{ ...singleNonGstSaleInvoice, returnTotal }}
											vatAmount={totalVatAmount}
											invoiceContainerRef={invoiceContainerRef}
                                            productsKey={"nonGstSaleInvoiceProduct"} 
										/>
							   	</div>
							     )}
							     {templateData?.invoiceTemplate === 'v3a4print' && (
							   	<div className={"text-end mr-2"}>
							   		<SaleInvoiceV3A4
							   			data={{ ...singleNonGstSaleInvoice, returnTotal }}
							   			vatAmount={totalVatAmount}
										invoiceContainerRef={invoiceContainerRef}
                                        productsKey={"nonGstSaleInvoiceProduct"} 
							   		/>
							   	</div>
							     )}

								{templateData?.packingSlipTemplate === 'a4pack' && (
								<div className={"text-end mr-2"}>
                                    <PackingSlip data={singleNonGstSaleInvoice} productsKey={"nonGstSaleInvoiceProduct"} />
								</div>
								)}
								{templateData?.packingSlipTemplate === '3pos' && (
								<div className={"text-end mr-2"}>
									<PackingSlip1 data={singleNonGstSaleInvoice} productsKey={"nonGstSaleInvoiceProduct"} />
								</div>
								)}
								{templateData?.invoiceTemplate === '3posprint' && (
								<div className={"text-end mr-2"}>
									<PosPrint
										data={{ ...singleNonGstSaleInvoice, returnTotal }}
										vatAmount={totalVatAmount}
										invoiceContainerRef={invoiceContainerRef}
                                        productsKey={"nonGstSaleInvoiceProduct"}
									/>
								</div>
								)}
								{templateData?.invoiceTemplate === '4posprint' && (
								<div className={"text-end mr-2"}>
									<PosPrint1
										data={{ ...singleNonGstSaleInvoice, returnTotal }}
										vatAmount={totalVatAmount}
										invoiceContainerRef={invoiceContainerRef}
                                        productsKey={"nonGstSaleInvoiceProduct"}
									/>
								</div>
								)}
								  {templateData?.invoiceTemplate === 'PosPrint3inch' && (
								<div className={"text-end mr-2"}>
									<PosPrint3inch
										data={{ ...singleNonGstSaleInvoice, returnTotal }}
										vatAmount={totalVatAmount}
										invoiceContainerRef={invoiceContainerRef}
                                        productsKey={"nonGstSaleInvoiceProduct"}
									/>
								</div>
								)}
								{templateData?.invoiceTemplate === 'PosPrint4inch' && (
								<div className={"text-end mr-2"}>
									<PosPrint4inch
										data={{ ...singleNonGstSaleInvoice, returnTotal }}
										vatAmount={totalVatAmount}
										invoiceContainerRef={invoiceContainerRef}
                                        productsKey={"nonGstSaleInvoiceProduct"}
									/>
								</div>
								)}
								{templateData?.invoiceTemplate === '3inch' && (
								<div className={"text-end mr-2"}>
									<PosPrint3inch1
										data={{ ...singleNonGstSaleInvoice, returnTotal }}
										vatAmount={totalVatAmount}
										invoiceContainerRef={invoiceContainerRef}
                                        productsKey={"nonGstSaleInvoiceProduct"}
									/>
								</div>
								)}
								{templateData?.invoiceTemplate === '4inch' && (
								<div className={"text-end mr-2"}>
									<PosPrint4inch1
										data={{ ...singleNonGstSaleInvoice, returnTotal }}
										vatAmount={totalVatAmount}
										invoiceContainerRef={invoiceContainerRef}
                                        productsKey={"nonGstSaleInvoiceProduct"}
									/>
								</div>
								)}
								  
								<Button type='primary' loading={loadingSendInvoice} className="mr-2" shape='round' onClick={() => handleSendInvoice(singleNonGstSaleInvoice.id, invoiceContainerRef)}>Send Invoice</Button>
								<div className='text-end mr-2'>
									<ChangeOrderStatus saleId={singleNonGstSaleInvoice.id} />
								</div>
							</div>
							<div className='card-body mt-5'>
								<Row justify='space-around'>
									<Col span={11}>
										<Badge.Ribbon
											text={status}
											color={status === "PAID" ? "green" : "red"}>
											<Badge.Ribbon
												text={singleNonGstSaleInvoice.orderStatus}
												color={
													singleNonGstSaleInvoice.orderStatus === "received"
														? "cyan"
														: "volcano"
												}
												className='mt-10'>
												<CardComponent title='Sale Invoice Information '>
													<h5 className='text-center mt-2 mb-2'>
														Initial Invoice Info
													</h5>

													<p>
														<Typography.Text strong>
															Total M.R.P :
														</Typography.Text>{" "}
														<strong>
															{singleNonGstSaleInvoice?.totalMRP ? Number(singleNonGstSaleInvoice.totalMRP * singleNonGstSaleInvoice?.productQty ).toFixed(3) : 0}
														</strong>
													</p>

													<p>
														<Typography.Text strong>
															Product Discount :
														</Typography.Text>{" "}
														<strong>
															{singleNonGstSaleInvoice?.productDiscount ? Number(singleNonGstSaleInvoice.productDiscount * singleNonGstSaleInvoice?.productQty).toFixed(3) : 0}
														</strong>
													</p>

													<p>
														<Typography.Text strong>
															Total After Discount :
														</Typography.Text>{" "}
														<strong>
															{singleNonGstSaleInvoice?.totalAmount ? Number(singleNonGstSaleInvoice.totalAfterDiscount).toFixed(3) : 0}
														</strong>
													</p>

													{storeGSTCode === customerGSTCode || !customerGSTCode ? 
													<div>
														<p>
															<Typography.Text strong>
																Product CGST :
															</Typography.Text>{" "}
															<strong>
																{singleNonGstSaleInvoice?.productTax ? Number(singleNonGstSaleInvoice.productTax / 2).toFixed(3) : 0}
															</strong>
														</p>

														<p>
															<Typography.Text strong>
																Product SGST :
															</Typography.Text>{" "}
															<strong>
																{singleNonGstSaleInvoice?.productTax ? Number(singleNonGstSaleInvoice.productTax / 2).toFixed(3) : 0}
															</strong>
														</p>
													</div> :
													<div>
														<p>
															<Typography.Text strong>
																Product IGST :
															</Typography.Text>{" "}
															<strong>
																{singleNonGstSaleInvoice?.productTax ? Number(singleNonGstSaleInvoice.productTax).toFixed(3) : 0}
															</strong>
														</p>
													</div>
													}

													<p>
														<Typography.Text strong>
															Total With GST :
														</Typography.Text>{" "}
														<strong>
															{singleNonGstSaleInvoice?.totalAmount ? Number(singleNonGstSaleInvoice.totalAmount).toFixed(3) : 0}
														</strong>
													</p>

													<p>
														<Typography.Text strong>Overall Discount: </Typography.Text>{" "}
														<strong>
														{singleNonGstSaleInvoice?.discount_type == "amount" ? "₹" :" "}{singleNonGstSaleInvoice?.discount ? Number(singleNonGstSaleInvoice.discount).toFixed(2) : 0}{singleNonGstSaleInvoice?.discount_type == "percentage" ? "%" :" "}
														</strong>
													</p>

													<p>
														<Typography.Text strong>
															Total Amount :
														</Typography.Text>{" "}
														<strong>
															{singleNonGstSaleInvoice?.totalAmount ? Number(singleNonGstSaleInvoice.grandTotal).toFixed(3) : 0}
														</strong>
													</p>

													<p>
														<Typography.Text strong>
															Paid Amount :
														</Typography.Text>{" "}
														<strong>
															{singleNonGstSaleInvoice?.paidAmount ? Number(singleNonGstSaleInvoice.paidAmount).toFixed( 3 ) : 0}
														</strong>
													</p>

													<p>
														<Typography.Text strong>
															Due Amount :
														</Typography.Text>{" "}
														<strong style={{ color: "red" }}>
															{" "}
															{singleNonGstSaleInvoice?.dueAmount ? Number(singleNonGstSaleInvoice.dueAmount).toFixed(3) : 0}
														</strong>
													</p>

													<p>
														<Typography.Text strong>Profit :</Typography.Text>{" "}
														<strong>
															{singleNonGstSaleInvoice?.profit
																? Number(singleNonGstSaleInvoice.profit).toFixed(3)
																: 0}
														</strong>
													</p>

													<p>
														<Typography.Text strong>
															Sale Date :
														</Typography.Text>{" "}
														<strong>
															{singleNonGstSaleInvoice.createdAt.slice(0, 10)}
														</strong>
													</p>

													<div>
														<h5 className='text-center mt-2 mb-2'>
															Update Invoice Info
														</h5>

														<p>
															<Typography.Text strong>
																Total Paid Amount :
															</Typography.Text>{" "}
															<strong>
																{totalPaidAmount
																	? Number(totalPaidAmount).toFixed(3)
																	: 0}
															</strong>
														</p>
														<p>
															<Typography.Text strong>
																Total GST Amount :
															</Typography.Text>{" "}
															<strong>
																{totalVatAmount ? Number(totalVatAmount).toFixed(3) : 0}
															</strong>
														</p>

														<p>
															<Typography.Text strong>
																Total Return Amount:
															</Typography.Text>{" "}
															<strong>
																{totalReturnAmount
																	? Number(totalReturnAmount).toFixed(3)
																	: 0}
															</strong>
														</p>

														<p>
															<Typography.Text strong>
																Due Amount :
															</Typography.Text>{" "}
															<strong style={{ color: "red" }}>
																{dueAmount ? Number(dueAmount).toFixed(3) : 0}
															</strong>
														</p>
													</div>
												</CardComponent>
											</Badge.Ribbon>
										</Badge.Ribbon>
									</Col>
									<Col span={12}>
										<CardComponent title='Customer Information'>
											<p>
												<Typography.Text strong>
													Customer Name :
												</Typography.Text>{" "}
												<strong>{singleNonGstSaleInvoice.customer.name}</strong>
											</p>

											<p>
												<Typography.Text strong>Phone :</Typography.Text>{" "}
												<strong>{singleNonGstSaleInvoice.customer.phone}</strong>
											</p>

											<p>
												<Typography.Text strong>Address :</Typography.Text>{" "}
												<strong>{singleNonGstSaleInvoice.customer.address}</strong>
											</p>
										</CardComponent>
									</Col>
								</Row>
								<br />
							</div>
						</Card>
						<SaleProductListCard list={singleNonGstSaleInvoice.nonGstSaleInvoiceProduct} />

						<ReturnSaleInvoiceList list={returnNonGstSaleInvoice} />

                        <TransactionSaleList list={transactions} isNonGet />
					</Fragment>
				) : (
					<Loader />
				)}
			</div>
		</div>
	);
};

export default DetailNonGstSale;
